import moment from 'moment';
import { SESSION as A  } from 'actions/sessionActions';

// The 'started' should remain the same once the user
// lands on the page. The 'current' gets updated each
// time the user moved the mouse. The 'expiration' is
// based on 'current' in the other code. The 'data' is
// the base64 decoded token, and 'token' is, obviously,
// the JWT token.
const init = {
    active: false,
    token: null,
    data: null,
    notice: null,
    started: moment.utc().unix(),
    current: moment.utc().unix(),
    expiration: moment.utc().minutes(20).unix(),
    showSesionExpiredModal: false
}

export default (state=init, action) => {
    switch(action.type) {
        // This allows the main aspects of the session state to be
        // overwritten. The initial purpose is to set the state of
        // a session to active, with the token and data.
        case A.SET_SESSION:
            const { active, token, data } = action.payload;
            return {...state, active: active, token: token, data: data };

        // Resets all the session information. Effectively
        // ending the session on the front-end.
        case A.CLEAR_SESSION: return {...init};

        // Set the notice type in the state.
        case A.SET_NOTICE: return {...state, notice: action.payload };

        // Stores the session token.
        case A.SET_SESSION_TOKEN: return {...state, token: action.payload };

        // Decodes the JWT token data and stores it in this
        // piece of the session state.
        case A.SET_SESSION_DATA: return {...state, data: action.payload };

        // Sets the 'current' time and moves the expiration
        // out to 20 minutes past that time.
        case A.SET_SESSION_CURRENT: return {...state,
            current: moment.utc().unix(),
            expiration: moment.utc().minutes(20).unix()
        };

        case A.TOGGLE_SESSION_EXPIRED_MODAL: return {...state,
            showSesionExpiredModal: !state.showSesionExpiredModal
        };

        default:
            return {...state}
    }
}
